import React from 'react';
import { Link } from 'react-router-dom';
import { PRIORITY_DREAM_KEYWORDS } from 'seo/sitemapConfig';

const POPULAR_NUMBERS = ['65', '88', '35', '19', '07', '59', '23', '42', '99', '16'];

const TOPIC_LINKS = [
  { label: 'ไพ่ยิปซีเลขนำโชค', href: '/tarot' },
  { label: 'เลขเด็ดงวดนี้', href: '/#hints' },
  { label: 'ผลรางวัลหวย', href: '/#prizes' },
  { label: 'สถิติหวยย้อนหลัง', href: '/#stats' },
  { label: 'บทความเลขเด็ด', href: '/#articles' },
];

export default function SeoInternalLinks() {
  const dreams = PRIORITY_DREAM_KEYWORDS.slice(0, 16);

  return (
    <section className="seo-internal-links" aria-labelledby="seo-links-heading">
      <h2 id="seo-links-heading" className="seo-internal-links__title">
        ค้นหาเลขเด็ดยอดนิยม
      </h2>
      <p className="seo-internal-links__desc">
        ทำนายฝัน หาเลขนำโชค เช็คสถิติหวยย้อนหลัง 32 ปี — คลิกเพื่อดูผลลัพธ์ทันที
      </p>

      <div className="seo-internal-links__group">
        <h3 className="seo-internal-links__label">ทำนายฝัน</h3>
        <ul className="seo-internal-links__list">
          {dreams.map((keyword) => (
            <li key={keyword}>
              <Link to={`/search/${encodeURIComponent(keyword)}`}>
                ฝันเห็น{keyword}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="seo-internal-links__group">
        <h3 className="seo-internal-links__label">เช็คสถิติเลข</h3>
        <ul className="seo-internal-links__list">
          {POPULAR_NUMBERS.map((num) => (
            <li key={num}>
              <Link to={`/search/${num}`}>เลข {num}</Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="seo-internal-links__group">
        <h3 className="seo-internal-links__label">หัวข้อหลัก</h3>
        <ul className="seo-internal-links__list">
          {TOPIC_LINKS.map((link) => (
            <li key={link.href}>
              <a href={link.href}>{link.label}</a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
